import { useEffect, useState } from 'react'

import { SHIFT_READ_GAP_MS } from '@krp/resource-aqsi-ui'

/** F5 не ускоряет опрос кассы. Дожидаемся прежнего срока, не выдавая память браузера за факт смены. */
export function useShiftReadDelay(key: string, lastAt: number | undefined): number | null {
  const deadline = () => {
    const now = Date.now()
    return lastAt !== undefined && lastAt <= now && lastAt + SHIFT_READ_GAP_MS > now ? lastAt + SHIFT_READ_GAP_MS : null
  }
  const [entry, setEntry] = useState(() => ({ key, until: deadline() }))
  if (entry.key !== key) setEntry({ key, until: deadline() })
  const until = entry.key === key ? entry.until : null
  useEffect(() => {
    if (until === null) return undefined
    const timer = setTimeout(() => setEntry({ key, until: null }), Math.max(0, until - Date.now()))
    return () => clearTimeout(timer)
  }, [key, until])
  return until
}
